const STATUS_ACTIONS = {
  //get status
  GET_STATUS_REQUEST: "GET_STATUS_REQUEST",
  GET_STATUS_SUCCESS: "GET_STATUS_SUCCESS",
  GET_STATUS_FAIL: "GET_STATUS_FAIL",
  //get all status
  GET_ALL_STATUS: "GET_ALL_STATUS",
  GET_ALL_STATUS_SUCCESS: "GET_ALL_STATUS_SUCCESS",
  GET_ALL_STATUS_FAIL: "GET_ALL_STATUS_FAIL",
  //get status by id
  GET_STATUS_BY_ID: "GET_STATUS_BY_ID",
  GET_STATUS_BY_ID_SUCCESS: "GET_STATUS_BY_ID_SUCCESS",
  GET_STATUS_BY_ID_FAIL: "GET_STATUS_BY_ID_FAIL",
  //add status
  POST_STATUS: "POST_STATUS",
  POST_STATUS_SUCCESS: "POST_STATUS_SUCCESS",
  POST_STATUS_FAIL: "POST_STATUS_FAIL",
  //delete status
  DELETE_STATUS: "DELETE_STATUS",
  DELETE_STATUS_SUCCESS: "DELETE_STATUS_SUCCESS",
  DELETE_STATUS_FAIL: "DELETE_STATUS_FAIL",
  //edit status
  EDIT_STATUS: "EDIT_STATUS",
  EDIT_STATUS_SUCCESS: "EDIT_STATUS_SUCCESS",
  EDIT_STATUS_FAIL: "EDIT_STATUS_FAIL",
};
export default STATUS_ACTIONS;
